import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
// import PETROLSIDE from "../../../assets/png/PETROLSIDE.png";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZPetrolFeatures from "../../../components/NZComponent/NzPetrol/NZPetrolFeatures";
import NZPetrolModels from "../../../components/NZComponent/NzPetrol/NZPetrolModels";
import NZPetrolSafety from "../../../components/NZComponent/NzPetrol/NZPetrolSafety";
import NZPetrolSpec from "../../../components/NZComponent/NzPetrol/NZPetrolSpec";
import PETROLSIDE from "../../../assets/images/Tuatara1000WindscreenElevated.jpg";

const NzPetrol = () => {
  let navigate = useNavigate();
  return (
    <>
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img src={HomeIcon} alt="HomeIcon" className="cursor-pointer" onClick={() => navigate("/")} />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Petrol`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[50px]">
          <div className="h-[400px] md:h-[720px] w-full">
            <div
              className="h-[400px] w-full md:h-full"
              style={{
                backgroundImage: `url(${PETROLSIDE})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
          <div className="p-[50px]  pt-[20px] md:pt-[100px] pb-[20px]">
            <div
              className="text-white kuunari-bold 
              text-[20px] 
              md:text-[40px] 
              lg:text-[60px]  
              leading-[32px]
              md:leading-[42px] 
              lg:leading-[62px]
              mb-[11px] 
              text-center 
              max-w-[511px] 
              mx-auto"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              Petrol TUATARA 1000 EFI UTV
            </div>
            <p className="text-[#666666] md:text-[20px] text-[16px] leading-[26px] text-center montserrat-medium">
              The Tuatara ATV / UTV 1000 EFI is a well-tested design that has been around for over 12 years With its
              powerful 1000cc car engine, and equipped with 4WD and differential lock on both axles this side-by-side
              UTV can pretty much go wherever you point it. The Tuatara 1000 EFI is also equipped with a 50 litre fuel
              tank, and given the engine’s amazing economy, most operators are only refuelling once a week. And the
              towing and carrying capacity has to be seen to be believed.
            </p>

            {/* <div className="md:mt-[140px] mt-[10px] text-center flex items-center justify-center flex-wrap">
              <button className="bg-[#78C15A]  px-[30px] text-white leading-[40px] text-[16px] m-[10px]">
                Phone Now
              </button>
              <button
                className="bg-[#78C15A]  px-[30px] text-white leading-[40px] text-[16px] m  -[10px]"
                onClick={() => {
                  const section = document.getElementById("contact-form");
                  const sectionTop = section.getBoundingClientRect().top + window.pageYOffset; // Section's top position relative to the viewport
                  const offset = 300; // Adjust for the desired offset
                  window.scrollTo({
                    top: sectionTop - offset,
                    behavior: "smooth",
                  });
                }}
              >
                CONTACT US
              </button>
            </div> */}
          </div>
        </div>

        <div>
          {/* <PETROLModels /> */}
          <NZPetrolFeatures />
          <NZPetrolModels />
          <NZPetrolSafety />
          <NZPetrolSpec />
          {/* <HighLevelSpecs />
          <NZNZPetrolGregFarrier />
          <NZElectricaTV /> */}
        </div>
        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzPetrol;
